<template>
    <b-modal
      v-if="filter"
      id="ag-logFilter-Modal"
      class="agModal"
      ref="modal"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @keyup.enter.native="applyFilterButton_click">
      <template slot="modal-header">
        <h4 class="agModal-title">Filter</h4>
      </template>
      <div class="agInputGroup">
        <label>Workflow:</label>
        <b-form-select 
          class="agMediumInput"
          v-model="filter.workflow" 
          :options="filterWfs" 
          @change="workflowField_change">
        </b-form-select>
      </div>
      <div class="agInputGroup">
        <label>Level:</label>
        <b-form-select 
          class="agMediumInput"
          v-model="filter.level" 
          :options="filterLevels" 
          @change="levelField_change">
        </b-form-select>
      </div>
      <div class="agInputGroup">
        <label>Start Date:</label>
        <datetime 
          v-model="filter.startDate"
          type="datetime"
          format="M/dd/yy h:mm a"
          :phrases="{ok: 'Set', cancel: 'Cancel'}">
        </datetime>
        <b-button class="agTextButton agInputGroup-append" @click="clearFilterDateButton_click('start')">Clear</b-button>
      </div>
      <div class="agInputGroup">
        <label>End Date:</label>
        <datetime 
          v-model="filter.endDate"
          type="datetime"
          format="M/dd/yy h:mm a"
          :phrases="{ok: 'Set', cancel: 'Cancel'}">
        </datetime>
        <b-button class="agTextButton agInputGroup-append" @click="clearFilterDateButton_click('end')">Clear</b-button>
      </div>
      <template slot="modal-footer" slot-scope="{cancel}">
        <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
        <b-button class="agModal-buttonRight" variant="primary" @click="applyFilterButton_click">Apply</b-button>
        <b-button class="agModal-buttonRight" variant="danger" @click="clearFilterButton_click">Clear</b-button>
      </template>
    </b-modal>
</template>


<script>

// components

// modules
import Util from "src/util/util";
import Moment from "moment";
import { Datetime } from "vue-datetime";

export default 
{
    name: "ag-logFilter-modal",
    components: {
        "datetime" : Datetime
    },
    props: {
        filter: Object
    },
    data(){
        return {
            filterLevels: [
              {value: "0", text: "-- None --"},
              {value: "1", text: "Error"},
              {value: "-1", text: "System"}
          ],
        }
    },
    computed:  {
        filterWfs()
        {
            var filterWfs = [{value: "-- None --", text: "-- None --"}];
            for(var i = 0; i < this.$store.state.wfStore.workflows.length; i++)
            {
                var wf = this.$store.state.wfStore.workflows[i];
                var filterWf = {value: wf.name, text: wf.name};
                filterWfs.push(filterWf);
            }
            return filterWfs;
        }
    },
    methods: 
    {
        // UI Events

        clearFilterButton_click()
        {
            this.$emit("clearFilter");
        },

        applyFilterButton_click()
        {
            this.$emit("applyFilter");
        },

        workflowField_change() {
          if(this.filter.workflow == "-- None --") {
            this.filter.workflow = null;
          }
        },

        levelField_change() {
          if(this.filter.level == "-- None --") {
            this.filter.level = null;
          }
        },

        // other

        show(){
            setTimeout(() => {
              this.$refs.modal.show();
            }, 250);
        },

        hide(){
          this.$refs.modal.hide();
        },
    }
};

</script>


<style scoped lange="css">


</style>


// WEBPACK FOOTER //
// src/components/log/FilterModal.vue